import PropTypes from 'prop-types';
import React from 'react';

const Merchant = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    className={className}
  >
    <path
      d="M10,3.5V7.96a2.0007,2.0007,0,0,0,4,0L13.6231,3.5Z"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14,7.96a1.98,1.98,0,0,0,2,1.9477h0A1.98,1.98,0,0,0,18,7.96L16.8692,3.5H13.6231Z"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.1308,3.5,2,7.96A1.98,1.98,0,0,0,4,9.9076,1.98,1.98,0,0,0,6,7.96L6.3769,3.5Z"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.3769,3.5,6,7.96a2.0007,2.0007,0,0,0,4,0V3.5Z"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="3.212 11.007 3.212 16.5 16.781 16.5 16.781 11.007"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="3.3159"
      y1="13.8282"
      x2="16.7811"
      y2="13.8282"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Merchant.propTypes = {
  className: PropTypes.string,
};

export default Merchant;
